let state = { items: [] };
const listeners = new Set();
function emitChange() {
    for (const listener of Array.from(listeners)) {
        listener();
    }
}
export function subscribe(listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
export function getSnapshot() {
    return state;
}
export function pushDialog(component) {
    const id = crypto.randomUUID();
    const item = { id, component };
    state = { items: [...state.items, item] };
    emitChange();
    const close = () => {
        const index = state.items.findIndex(x => x.id === id);
        if (index !== -1) {
            const next = state.items.slice();
            next.splice(index, 1);
            state = { items: next };
            emitChange();
        }
    };
    const update = (nextComponent) => {
        const index = state.items.findIndex(x => x.id === id);
        if (index !== -1) {
            const next = state.items.slice();
            next[index] = { id, component: nextComponent };
            state = { items: next };
            emitChange();
        }
    };
    return { id, close, update };
}
//# sourceMappingURL=dialogs-store.js.map